module.exports = __webpack_public_path__ + "img/queerean-voices-logo.c7266db4.svg";